import { createSlice } from "@reduxjs/toolkit";
import { SimpleSetter, SliceActions } from "store";

export type BusinessObjectItem = { id: string; name: string };

export type BusinessObjectsState = {
	list: BusinessObjectItem[];
	loading: boolean;
	error: string;
};

const initialState: BusinessObjectsState = {
	list: [],
	loading: false,
	error: "",
};

export const BusinessObjectsSlice = createSlice({
	name: "businessObjects",
	initialState,
	reducers: {
		SetList: SimpleSetter<BusinessObjectsState, BusinessObjectItem[]>("list"),
		SetLoading: SimpleSetter<BusinessObjectsState, boolean>("loading"),
		SetError: SimpleSetter<BusinessObjectsState, string>("error"),
	},
	selectors: {
		selectList: (s) => s.list,
		selectLoading: (s) => s.loading,
		selectError: (s) => s.error,
	},
});

export type BusinessObjectsAction = SliceActions<typeof BusinessObjectsSlice>;
